import { AxiosError } from "axios";

export const getAxiosErrorMessage = (error: AxiosError): string => {
  const data = error.response?.data;

  if (!data) return error.message || "An unknown error occurred.";

  if (typeof data === "string") return data;

  if (typeof data === "object") {
    const errorData = data as Record<string, any>;

    if (errorData.message) {
      if (typeof errorData.message === "string") return errorData.message;
      if (typeof errorData.message === "object") {
        return Object.values(errorData.message).flat().join(" ");
      }
    }
    if (errorData.detail) return errorData.detail;

    const messages = Object.values(errorData).flat().filter(Boolean).join(" ");

    return messages || error.message || "An unknown error occurred.";
  }

  return error.message || "An unknown error occurred.";
};
